import apiClient from './apiClient';

export interface EmailTopStatsDto {
  totalProcessedEmailsCount: number;
  totalDeliveredEmailsCount: number;
  totalBouncedAndBlockedEmails: number;
  totalUniqueOpensEmailsCount: number;
}

export interface SmsTopStatsDto {
  totalFailedSmsCount: number;
  totalSentSmsCount: number;
  totalDeliveredSmsCount: number;
  totalUndeliveredSmsCount: number;
}

export interface EmailCountGroupedByDateDto {
  timestamp: string;
  processedCount: number;
  deliveredCount: number;
  bouncedCount: number;
  opensCount: number;
}

export interface SmsCountGroupedByDateDto {
  timestamp: string;
  sentCount: number;
  deliveredCount: number;
  failedCount: number;
  pendingCount: number;
}

export type GroupByScale = 'minute' | 'hour' | 'day' | 'week' | 'month' | 'year';

export const RequestAnalyticsService = {
  emails: {
    getStats: async (filters?: { customerId?: number; apiKeyId?: number }): Promise<EmailTopStatsDto> => {
      const response = await apiClient.get<EmailTopStatsDto>(`/api/v1/request-analytics/stats/emails`, { params: filters });
      return response.data;
    },
    getGroupedStats: async (
      startDate: string,
      endDate: string,
      groupBy: GroupByScale,
      filters?: { customerId?: number; apiKeyId?: number }
    ): Promise<EmailCountGroupedByDateDto[]> => {
      const response = await apiClient.get<EmailCountGroupedByDateDto[]>(
        `/api/v1/request-analytics/stats/emails/grouped`,
        { params: { startDate, endDate, groupBy, ...filters } }
      );
      return response.data;
    },
  },
  sms: {
    getStats: async (filters?: { customerId?: number; apiKeyId?: number }): Promise<SmsTopStatsDto> => {
      const response = await apiClient.get<SmsTopStatsDto>(`/api/v1/request-analytics/stats/sms`, { params: filters });
      return response.data;
    },
    getGroupedStats: async (
      startDate: string,
      endDate: string,
      groupBy: GroupByScale,
      filters?: { customerId?: number; apiKeyId?: number }
    ): Promise<SmsCountGroupedByDateDto[]> => {
      const response = await apiClient.get<SmsCountGroupedByDateDto[]>(
        `/api/v1/request-analytics/stats/sms/grouped`,
        { params: { startDate, endDate, groupBy, ...filters } }
      );
      return response.data;
    },
  },
};
